export enum EQueryKeys {
  COUNTRIES = 'countries',
  STATES = 'states',
  CITIES = 'cities',
  CURRENCIES = 'currencies',
  PLACING_TYPES = 'placingTypes',
  SUB_CLASSES = 'subClasses',
  BUSINESS_LINES = 'businessLines',
  PRINCIPAL_OCCUPATIONS = 'principalOccupations',
  MAIN_REGION_AND_RISK_TERRITORY_LIST = 'mainRegionAndRiskTerritoryList',
  DUPLICATED_CHECK = 'duplicatedCheck',
  INSURED_BY_ID = 'insuredById',
  REINSURED_BY_ID = 'reinsuredById',
  BROKER_BY_ID = 'brokerById',
  CAT_EVENT_BY_ID = 'catEventById',
  USERS = 'users',
  ASSIGNED_HANDLER_BY_ID = 'assignedHandlerById',
  SUBMISSION_BY_ID = 'submissionById',
  FILTER_LAYERS = 'filterLayers',
  NAMED_UNDERWRITER_BY_ID = 'namedUnderwriterById',
  SUB_LIMIT_SETTINGS = 'subLimitSettings',
  SUB_LIMITS = 'subLimits',
  BASIS_OF_COVERS = 'basisOfCovers',
  FILTER_SOV = 'filterSoV',
  GET_SOV_SUMMARY = 'getSoVSummary',
  FIRE_PRICING_SUMMARY = 'firePricingSummary',
  FIRE_PRICING_ANALYSIS = 'firePricingAnalysis',
  FIRE_MODIFIERS = 'fireModifiers',
  SOV_COUNTRIES = 'sovCountries',
  SOV_OCCUPANCIES = 'sovOccupancies',
  CAT_PRICING_SUMMARY = 'catPricingSummary',
  CAT_PRICING_ANALYSIS = 'catPricingAnalysis',
  GET_LAYER_RESULTS = 'getLayerResults',
  SOV_CRESTA_ZONES = 'sovCrestaZones',
  BINDER_LIST = 'binderList',
  BINDER_BY_ID = 'binderById',
  ALL_STATES = 'allStates',
  INSURED_LIST = 'insuredList',
  REINSURED_LIST = 'reinsuredList',
  BROKER_LIST = 'brokerList',
  CONTRACT_LIST = 'contractList',
  CAT_EVENT_LIST = 'catEventList',
  BINDING_DATA = 'bindingData',
  BINDING_DATA_FOR_SUBMISSION_DETAILS = 'bindingDataForSubmissionDetails',
  TOTAL_DEPLOYMENT_PER_BINDER = 'totalDeploymentPerBinder',
  REVIEW_NOTE_BY_SUBMISSION_ID = 'reviewNoteBySubmissionId',
  CONTRACT_BY_ID = 'contractById',
  GET_INSTALLMENT_DETAILS = 'getInstallmentDetails',
  LIST_RECEIPTS = 'listReceipts',
  LIST_RECEIPT_SOURCE_BROKERS = 'listReceiptSourceBrokers',
  LIST_RECEIPT_BANK_ACCOUNTS = 'listReceiptBankAccounts',
  LIST_RECEIPT_CURRENCIES = 'listReceiptCurrencies',
  LIST_BANK_ACCOUNTS = 'listBankAccounts',
  RECEIPT_BY_ID = 'receiptById',
  CONTRACT_AVAILABLE_FOR_ALLOCATION = 'contractAvailableForAllocation',
  CONTRACT_ALLOCATED_TO_RECEIPT = 'contractAllocatedToReceipt',
  GET_ORIGINAL_PREMIUM_SCHEDULE = 'getOriginalPremiumSchedule',
  PREMIUM_DUE_OPTIONS = 'premiumDueOptions',
  PREMIUM_DUE = 'premiumDue',
  CONTRACT_BALANCE = 'contractBalance',
  CONTRACT_PREMIUM_PAID = 'contractPremiumPaid',
  OPTIONS_PREMIUM_SCHEDULE_AVAILABLE_FOR_ALLOCATION = 'optionsPremiumScheduleAvailableForAllocation',
  LAZY_LOADING_SELECT = 'lazyLoadingSelect',
  BROKER_GROUPS = 'brokerGroups',
  MASTER_CLAIMS = 'masterClaims',
  BINDER_CLAIMS = 'binderClaims',
  BUSINESS_LINES_CLAIMS = 'businessLinesClaims',
  LOSS_CAUSES = 'lossCauses',
  DECLARATION_SCHEDULE_BY_CONTRACT = 'declarationScheduleByContract',
  LIST_CONTRACT_ADJUSTMENTS = 'listContractAdjustments',
  GET_CONTRACT_ADJUSTMENT_DETAILS = 'getContractAdjustmentDetails',
  RECEIPT_SETTLEMENT_EXCHANGE_RATE = 'receiptSettlementExchangeRate',
  ORIGINAL_CURRENCIES_FOR_ALLOCATION = 'originalCurrenciesForAllocation',
  CONTRACT_FILTER_OPTIONS = 'contractFilterOptions',
  MASTER_CLAIMS_INSURED_LAZY_LOADING_SELECT = 'masterClaimsInsuredLazyLoadingSelect',
  CLAIM_CONTRACT_ALLOCATION = 'claimContractAllocation',
  CLAIM_BY_ID = 'claimById',
  REGISTER_CLAIM_CONTRACT_ALLOCATION = 'registerClaimContractAllocation',
  REINSURED_LAZY_LOADING_SELECT = 'reinsuredLazyLoadingSelect',
  BROKER_LAZY_LOADING_SELECT = 'brokerLazyLoadingSelect',
  TBA_CONFIG = 'tbaConfig',
}
